import { forwardRef, type TextareaHTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  hasError?: boolean;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { className, hasError, ...rest },
  ref,
) {
  return (
    <textarea
      ref={ref}
      className={cn(
        // 16px until sm: — anything smaller makes iOS Safari zoom the page on focus.
        'min-h-[5rem] w-full rounded-md border bg-parchment-light px-3 py-2 text-base text-parchment-ink',
        'sm:text-sm',
        'placeholder:text-parchment-subtle resize-y',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-1 focus-visible:ring-offset-parchment-light',
        hasError
          ? 'border-danger focus-visible:ring-danger'
          : 'border-parchment-border focus-visible:ring-accent',
        'disabled:cursor-not-allowed disabled:opacity-60',
        className,
      )}
      {...rest}
    />
  );
});
